import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UsuarioAdminService } from '../../../shared/services/apis/usuario-admin/usuario-admin.service';
import { ListaUsuarioAdminResponse } from '../../../shared/services/responses/usuario-admin/lista-usuario-admin.response';
import { UsuarioAdminListaStruct } from '../../../shared/services/structs/usuario-admin/usuario-admin-lista.struct';
import { MatSelectModule } from '@angular/material/select';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';

@Component({
  selector: 'app-usuario-admin-lista',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatSelectModule,
    TemPermissaoDirective,
  ],
  templateUrl: './usuario-admin-lista.component.html',
  styleUrl: './usuario-admin-lista.component.css',
})
export class UsuarioAdminListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private usuarioAdminService: UsuarioAdminService,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {
    this.moduloEnum = ModuloEnum.Master;
    this.funcionalidadeEnum = FuncionalidadeEnum.Master_Usuario;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaUsuarioResponse: ListaUsuarioAdminResponse | undefined;
  public displayedColumns: string[] = [
    'idUsuarioAdmin',
    'nomeUsuarioAdmin',
    'email',
    'telefone',
    'action-edit',
    'action-delete',
  ];
  public _dataSource = new MatTableDataSource<UsuarioAdminListaStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _PermissaoEnum = PermissaoEnum;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      nomeUsuarioAdmin: [''],
    });

    this.pesquisar();
  }

  private pesquisar(): void {
    if (this.model.invalid || this._isLoading === true) {
      return;
    }

    this._isLoading = true;
    const nomeUsuarioAdmin: string = this.model.get('nomeUsuarioAdmin')?.value;

    this.usuarioAdminService.get(nomeUsuarioAdmin, this._paginaAtual).subscribe({
      next: (usuarioLoginResponse: ListaUsuarioAdminResponse) => {
        this._isLoading = false;
        if (usuarioLoginResponse.isError) {
          this.alertService.show('Erro', usuarioLoginResponse.errorDescription, AlertType.error);
          return;
        }

        this._ultimaPagina = true;

        if (!this._listaUsuarioResponse) {
          this._listaUsuarioResponse = usuarioLoginResponse;
          this._ultimaPagina = false;
        } else if (usuarioLoginResponse.listaUsuarioAdmin?.length > 0) {
          this._listaUsuarioResponse.listaUsuarioAdmin.push(...usuarioLoginResponse.listaUsuarioAdmin);
          this._ultimaPagina = false;
        }
        this._dataSource.data = this._listaUsuarioResponse.listaUsuarioAdmin;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaUsuarioResponse = undefined;
    this.pesquisar();
  }

  abrirModalExcluir(idUsuarioAdmin: number, nomeUsuarioAdmin: string): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Alerta',
        description: `Deseja excluir o usuário ${nomeUsuarioAdmin}? Essa ação será irreversível.`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.excluir(idUsuarioAdmin);
        }
      },
    });
  }

  private excluir(idUsuarioAdmin: number): void {
    this.usuarioAdminService.excluir(idUsuarioAdmin).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.clickPesquisar();

        this.alertService.show('Sucesso', 'Usuário excluido com sucesso', AlertType.success);
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }
}
